import { PayloadAction } from '@reduxjs/toolkit';
import { PriceStrategy } from '@snap-types/models/enums';

import { ExtraReducerBuilder } from '../../types/shared';
import { WritableQuoteBuilderStateType } from '../../types/state';
import { createConfiguredPart } from '../endpoints/create-configured-part';
import { createSnapQuoteLine } from '../endpoints/create-snap-quote-line';
import { setNoLastWin } from '../utilities/common-issues';
import { transformSnapQuoteLineToStoreState } from '../utilities/transform-quote-line';

function createSnapQuoteLineFulfilled(
  state: WritableQuoteBuilderStateType,
  action: PayloadAction<typeof createSnapQuoteLine.Types.ResultType>,
) {
  const { quoteLine, hasLastWin, uuid } = transformSnapQuoteLineToStoreState(
    action.payload,
    state.calculationConfig,
  );

  const { lineNumber, uuid: quoteLineUuid, priceStrategy } = quoteLine;

  // maintain lineNumber order when inserting the new quote line
  state.quoteLineUuids.splice(lineNumber - 1, 0, uuid);
  state.quoteLines[uuid] = quoteLine;

  state.dialog = null;

  const skipNoLastWinStrategies: PriceStrategy[] = [
    PriceStrategy.NewPartUserPrice,
    PriceStrategy.NewPart,
  ];

  if (!hasLastWin && !skipNoLastWinStrategies.includes(priceStrategy)) {
    setNoLastWin(state, quoteLineUuid);
  }
}

function createSnapQuoteLineRejected(state: WritableQuoteBuilderStateType) {
  state.dialog = null;
}

export function createSnapQuoteLineReducer(builder: ExtraReducerBuilder) {
  builder.addMatcher(
    createSnapQuoteLine.matchFulfilled,
    createSnapQuoteLineFulfilled,
  );
  builder.addMatcher(
    createSnapQuoteLine.matchRejected,
    createSnapQuoteLineRejected,
  );

  builder.addMatcher(
    createConfiguredPart.matchFulfilled,
    createSnapQuoteLineFulfilled,
  );
}
